import React from 'react';
import '../styles.css';
import SignupForm from '../components/signup/SignupForm.js';
import AppBar from '../components/AppBar.js';

function SignupPage() {
    return (
        <div className='column'>
            <AppBar backTo='' displayText='Sign In' />
            <SignupForm />
        </div>
    )
}

export default SignupPage;